import { render, staticRenderFns } from "./Marquee.vue?vue&type=template&id=0c1e769f&"
import script from "YD/components/home/marquee.component?vue&type=script&lang=js&"
export * from "YD/components/home/marquee.component?vue&type=script&lang=js&"
import style0 from "./Marquee.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports